<template src="./SelectNormal.html"></template>

<script>
import {nextTick, ref, watch} from "vue";

export default {
  name: 'SelectNormal',
  props: {
    options: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    valueDefault: {
      type: String,
      required: false,
      default: () => ''
    },
    placeholder: {
      type: String,
      required: false,
      default: () => ''
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false
    },
    errorText: {
      type: String,
      required: false,
      default: () => ''
    },
  },
  emits: ['inputValue'],
  setup(props, {emit}) {
    const value = ref(props.valueDefault)
    const error = ref(props.errorText)
    const distanceWithLabel =  ref('0px')
    const labelForm = ref(null)

    watch(() => props.valueDefault, (newVal) => {
      value.value = newVal
    })
    watch(
        () => props.errorText,
        async (newError) => {
          error.value = newError
          await nextTick()
          distanceWithLabel.value =
              (labelForm.value?.offsetWidth || 0) + 10 + 'px'
        }
    )

    watch(() => value.value, (newVal) => {
      emit('inputValue', newVal, 'partner_id');
    })

    function chooseOption(key) {
      emit('inputValue', key, 'partner_id');
    }

    return {
      error,
      value,
      distanceWithLabel,
      labelForm,
      chooseOption
    }
  }
}
</script>

<style lang="scss">
  option[value=""][disabled] {
    display: none;
    color: #d9dee3;
  }
  option {
    color: black;
  }
  .required {
    color: red;
  }

  .select-form {
    position: relative;
  }
  .error-text {
    top: -5px;
    padding: .5rem .5rem;
    font-size: .76rem;
    color: #3a3a3a;
    background: #fff;
    border: 1px solid red;
    text-align: center;
    width: unset !important;
    position: absolute;
    z-index: 4;
    margin-top: -.5rem;
    line-height: 1.5;
    box-shadow: 0 1px 15px rgba(0, 0, 0, .04), 0 1px 6px rgba(0, 0, 0, .04);
    border-radius: 10px;
    &:before {
      content: "";
      position: absolute;
      left: -5px;
      right: initial;
      margin-left: 0;
      bottom: initial;
      top: 12px;
      width: 5px;
      border-top: 5px solid transparent;
      border-right: 5px solid red;
      border-bottom: 5px solid transparent;
    }
    &:after {
      content: "";
      position: absolute;
      left: -4px;
      right: initial;
      margin-left: 0;
      border-top: 5px solid transparent;
      border-right: 5px solid #fff;
      border-bottom: 5px solid transparent;
      bottom: initial;
      top: 12px;
      width: 5px;
    }
  }
</style>
